import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const cinderMessagesSelector = createSharedSelector(
  getDataSelector<DataKeys.CinderMessages>(DataKeys.CinderMessages),
  (messages) => messages,
)

export const latestMessageByVolumeSelector = createSharedSelector(
  cinderMessagesSelector,
  (messages) => {
    const messagesByVolumeId = messages.reduce((accum, message) => {
      // Only get volume messages that are error messages
      if (message?.resource_type !== 'VOLUME' || message?.message_level !== 'ERROR') {
        return accum
      }
      // Only want latest a volume's latest message
      if (
        accum[message?.resource_uuid] &&
        accum[message?.resource_uuid].created_at > message?.created_at
      ) {
        return accum
      }
      return {
        ...accum,
        [message?.resource_uuid]: message,
      }
    }, {})
    return messagesByVolumeId
  },
)
